/** طول کد پایه تفصیلی (کل+معین+تفصیلی) */
export const ACCOUNT_BASE_CODE_LENGTH = 6;

/** طول پسوند پروژه در انتهای کد — مثال: 010101 + 1000 */
export const PROJECT_ACCOUNT_SUFFIX_LENGTH = 4;

export function normalizeAccountCodeDigits(code: string): string {
  return code.replace(/\D+/g, '');
}

export function parseAccountCodeProject(accountCode: string): {
  baseAccountCode: string;
  projectId: number | null;
  hasProjectSuffix: boolean;
} {
  const normalized = normalizeAccountCodeDigits(accountCode);
  const expectedLen = ACCOUNT_BASE_CODE_LENGTH + PROJECT_ACCOUNT_SUFFIX_LENGTH;

  if (normalized.length <= ACCOUNT_BASE_CODE_LENGTH) {
    return { baseAccountCode: normalized, projectId: null, hasProjectSuffix: false };
  }

  if (normalized.length !== expectedLen) {
    return { baseAccountCode: normalized, projectId: null, hasProjectSuffix: false };
  }

  const baseAccountCode = normalized.slice(0, ACCOUNT_BASE_CODE_LENGTH);
  const suffix = normalized.slice(ACCOUNT_BASE_CODE_LENGTH);
  const projectId = Number(suffix);

  if (!Number.isFinite(projectId) || projectId <= 0) {
    return { baseAccountCode: normalized, projectId: null, hasProjectSuffix: false };
  }

  return { baseAccountCode, projectId, hasProjectSuffix: true };
}

export function accountCodeForHeadingLookup(accountCode: string): string {
  const parsed = parseAccountCodeProject(accountCode);
  return parsed.hasProjectSuffix ? parsed.baseAccountCode : accountCode.trim();
}

export function encodeAccountCodeWithProject(accountCode: string, projectId?: number | null): string {
  const trimmed = accountCode.trim();
  if (!trimmed || !projectId || projectId <= 0) return trimmed;
  const parsed = parseAccountCodeProject(trimmed);
  if (parsed.hasProjectSuffix) return trimmed;
  const base = normalizeAccountCodeDigits(trimmed);
  if (base.length !== ACCOUNT_BASE_CODE_LENGTH) return trimmed;
  return `${base}${String(projectId).padStart(PROJECT_ACCOUNT_SUFFIX_LENGTH, '0')}`;
}
